import React from "react";
import { Box, Typography } from "@mui/material";
import SwiperComp from "../../../Swiper/Swiper";
import entrata from "../../../../assets/picsAppartamenti/agenzia1.jpeg";
import entrata1 from "../../../../assets/picsAppartamenti/agenzia2.png";
import entrata2 from "../../../../assets/picsAppartamenti/partenopei.jpg";
import LazyLoad from "react-lazyload";
import { Fade } from "react-awesome-reveal";
import RealEstateGrid from "./RealEstateGrid";
import RealEstateServizi from "./RealEstateServizi";

import {
  BrochureAtom31,
  BrochureAtom32,
  BrochureInfo,
} from "../../Brochure/BrochureAtoms/BrochureAtoms";
import { useTranslation } from "react-i18next";
import { Stack, useMediaQuery } from "@mui/system";

type Props = {
  isAbout?: boolean;
};
const YogaStart = ({ isAbout }: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const ingresso = [
    {
      image: entrata1,
      title: "Chi Siamo",
      text: <BrochureAtom31 />,
      bgColor: "#0b6e8d", // Colore di sfondo della sezione testuale
    },
    {
      image: entrata,
      title: "",
      text: <BrochureAtom32 />,
      bgColor: "#a1a1a1",
    },
    {
      image: entrata2,
      title: "",
      text: <BrochureInfo />,
      bgColor: "#0b6e8d",
    },
  ];
  return (
    <Box
      style={{
        zIndex: 1,
        width: "100%",
        display: "flex",
        flexDirection: isAbout ? "column-reverse" : "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          height: "150px",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            display: isAbout ? "none" : undefined,
            fontSize: isMobile ? "18px" : "43px",
            fontFamily: "ivymode",
            color: "#0C6D8D",
          }}
        >
          Servizi Partenope Immobiliare
        </Typography>
      </Stack>
      <RealEstateServizi />
      <div id="chisiamo" style={{ marginTop: "50px" }} />
      <Fade duration={2000}>
        <LazyLoad>
          <SwiperComp
            isAbout
            slides={ingresso}
            height={isAbout ? "100vh" : "90vh"}
            id="ingresso"
          />
        </LazyLoad>
      </Fade>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          height: isAbout ? 0 : "100px",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            display: isMobile ? "none" : undefined,
            fontSize: "24px",
            fontFamily: "degular",
            color: "#0C6D8D",
          }}
        >
          Annunci in evidenza
        </Typography>
      </Stack>
      {isAbout ? null : <RealEstateGrid />}
    </Box>
  );
};
//  scroll={scroll} remember window.scrollY
export default React.memo(YogaStart);
